/* RadiusConfigComponent.js */

"use strict";
const _ = require("lodash");
const Steve = require("@gluenetworks/steve_core").getInstance();
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./RadiusConfigRenderer");

class RadiusConfigComponent extends EventEmitter {
    constructor({orgInfo, userInfo, isProvider, credentialsList}) {
        super();
        this._orgInfo = orgInfo;
        this._userInfo = userInfo;
        this._actionGroupEntity = Steve.di.getRegistered(
            "$teve.entities.ActionGroup"
        ).registeredObj;
        this._actionGroupsFeed = undefined;
        this._providerId = undefined;
        this._isProvider = isProvider; // boolean
        this._isEnabled = false;
        this._credentialsList = credentialsList;
        this._renderer = new Renderer(this);

        this._setDefaultSelectedOrgInfo();
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this.on("ProviderUpdated", (this._onProviderUpdated = this._onProviderUpdated.bind(this)));
    }

    _unregisterListeners() {
        this.removeAllListeners("ProviderUpdated");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._renderer = undefined;
                this._providerId = undefined;
                this._isProvider = undefined;
                this._isEnabled = undefined;
            },
            () => {
                //TODO - Handle any errors in shutting down.
            }
        );
    }

    get actionGroupsFeed() {
        return this._actionGroupsFeed;
    }

    set actionGroupsFeed(newFeed) {
        this._actionGroupsFeed = newFeed;
    }

    whenModelIsReady() {
        /*
        if (_.isEmpty(this.actionGroupsFeed)) {
            this.actionGroupsFeed = this._actionGroupEntity.startAscendActionGroupsFeed(
                this._orgInfo.id,
                {},
                {},
                {},
                { skip: 0, limit: 40 * 2 }
            );
        } else {
            this.actionGroupsFeed.reestablishFeed(this._orgInfo.id);
        }
        return this.actionGroupsFeed.whenInitialized();
        */
        const orgId = this._isProvider ? this._providerId : this._orgInfo.id;
        if (!orgId) {
            return Promise.resolve();
        }
        return this._actionGroupEntity.loadAscendActionGroups(orgId).then((actionGroupsFeed) => {
            this.actionGroupsFeed = actionGroupsFeed;
            return Promise.resolve();
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onProviderUpdated(val) {
        this._providerId = val;
        this._actionGroupEntity
            .loadAscendActionGroups(this._providerId)
            .then((actionGroupsFeed) => {
                this.actionGroupsFeed = actionGroupsFeed;
                this.emit("ActionGroupsFeedUpdated");
            });
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    emitTestRadius(data) {
        this.emit("testRADIUS", data);
    }

    _setDefaultSelectedOrgInfo() {
        this._orgInfo.radius = this._orgInfo.radius || {};
        this._orgInfo.radius.port = this._orgInfo.radius.port || 1812;
        this._orgInfo.radius.accountingPort = this._orgInfo.radius.accountingPort || 1813;
        this._orgInfo.radius.requestTimeout = this._orgInfo.radius.requestTimeout || 2000;
        this._orgInfo.radius.requestRetries = this._orgInfo.radius.requestRetries || 3;
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setEnabled(enabled) {
        this._isEnabled = enabled;
        this.emit("enableRADIUS", enabled);
    }

    get selectedOrgInfo() {
        return this.getSelectedOrgInfo();
    }

    set selectedOrgInfo(newInfo) {
        this.setSelectedOrgInfo(newInfo);
    }

    getSelectedOrgInfo() {
        return this._orgInfo;
    }

    setSelectedOrgInfo(newInfo) {
        this._orgInfo = newInfo;
        this._setDefaultSelectedOrgInfo();
        this.renderer.render();
    }

    setCredentialsList(credentialsList) {
        this._credentialsList = credentialsList || [];
    }

    get userInfo() {
        return this.getUserInfo();
    }

    getUserInfo() {
        return this._userInfo;
    }

    get saveModel() {
        return this.getSaveModel();
    }

    set saveModel(obj) {
        this.setSaveModel(obj);
    }

    getSaveModel() {
        if (_.isPlainObject(this._saveModel) && _.isEmpty(this._saveModel)) {
            return undefined;
        }
        return this._saveModel;
    }

    setSaveModel(obj) {
        this._saveModel = obj;
        this.emit("ModelUpdated");
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}
module.exports = RadiusConfigComponent;
